export default "<app-finance-registry></app-finance-registry>\r\n";